import { graphql } from '../../services/graphql'

import { useOnMount } from '../use-on-mount'
import { useStore } from '../state'

// `enabled` vaut false pour les comptes « client » : ces requêtes sont gardées
// par AdminAccess côté API et échoueraient à chaque abonnement.
export function useDatasourceAudio(enabled: boolean = true) {
  const Store = useStore()

  useOnMount(() => {
    if (!enabled) {
      return
    }

    return graphql.subscribe(['AudioTheme'], () => {
      graphql.queries
        .getAudioThemes()
        .then(({ audioThemeList }) =>
          Store.getActions().audio.setThemes(audioThemeList),
        )
    })
  })

  useOnMount(() => {
    if (!enabled) {
      return
    }

    return graphql.subscribe(['AudioBook'], () => {
      graphql.queries
        .getAudioBooks()
        .then(({ audioBookList }) =>
          Store.getActions().audio.setBooks(audioBookList),
        )
    })
  })

  useOnMount(() => {
    if (!enabled) {
      return
    }

    return graphql.subscribe(['AudioBackground'], () => {
      graphql.queries
        .getAudioBackgrounds()
        .then(({ audioBackgroundList }) =>
          Store.getActions().audio.setBackgrounds(audioBackgroundList),
        )
    })
  })

  useOnMount(() => {
    if (!enabled) {
      return
    }

    return graphql.subscribe(['Category'], () => {
      graphql.queries
        .getCategories()
        .then(({ categoryList }) =>
          Store.getActions().audio.setCategories(categoryList),
        )
    })
  })

  useOnMount(() => {
    if (!enabled) {
      return
    }

    return graphql.subscribe(['Gong'], () => {
      graphql.queries
        .getGongs()
        .then(({ gongList }) => Store.getActions().audio.setGongs(gongList))
    })
  })
}
